import { render, staticRenderFns } from "./CustomInputRegion.vue?vue&type=template&id=06e32ec5&"
import script from "./CustomInputRegion.controller.js?vue&type=script&lang=js&"
export * from "./CustomInputRegion.controller.js?vue&type=script&lang=js&"
import style0 from "./CustomInputRegion.styles.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports